import { AxiosError } from 'axios';
import { apiPost, apiPut } from './api';
import {
  IChangeSkyBody,
  IDeliveryProgress,
  IDeliveryComplet,
  IEditEstimatedDeliveryDate,
  IMassiveDeliveryInProgress
} from '../types/traking';

const { REACT_APP_SUBSCRIPTION } = process.env;

const goToConfirmed = async (shipmentId: number, shipmentStatusId: number) => {
  return apiPut(`${REACT_APP_SUBSCRIPTION}/order/shipment-status/${shipmentId}?shipmentStatusId=${shipmentStatusId}`)
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const goToDeliveryInProgress = async (shipmentId: number, body: IDeliveryProgress, shipmentStatusId: number) => {
  return apiPut(
    `${REACT_APP_SUBSCRIPTION}/order/shipment-status/${shipmentId}?shipmentStatusId=${shipmentStatusId}`,
    body
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const updateDateDelivery = async (shipmentId: number, body: IDeliveryProgress) => {
  return apiPut(`${REACT_APP_SUBSCRIPTION}/order/shipment/estimated-delivery-date/${shipmentId}`, body)
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const editEstimatedDeliveryDateInBulk = async (bodyEditEstimatedDeliveryDate: IEditEstimatedDeliveryDate) => {
  return apiPut(`${REACT_APP_SUBSCRIPTION}/order/shipment/estimated-delivery-date`, bodyEditEstimatedDeliveryDate)
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const goToDeliveryComplete = async (shipmentId: number, body: IDeliveryComplet, shipmentStatusId: number) => {
  return apiPut(
    `${REACT_APP_SUBSCRIPTION}/order/shipment-status/${shipmentId}?shipmentStatusId=${shipmentStatusId}`,
    body
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const finishDelivery = async (orderId: string) => {
  return apiPost(`${REACT_APP_SUBSCRIPTION}/order/shipment-status/${orderId}`)
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const autoUpdateSku = async (bodySkus: IChangeSkyBody) => {
  return apiPut(`${REACT_APP_SUBSCRIPTION}/product/change-by-sku`, bodySkus)
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const updateToConfirmetToInWarehouse = async (bodyMassiveDeliveryInProgress: IMassiveDeliveryInProgress[]) => {
  return apiPut(
    `${REACT_APP_SUBSCRIPTION}/order/shipment-status-masive/?shipmentStatusId=6`,
    bodyMassiveDeliveryInProgress
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const massUpdateConfirmedToInProgress = async (bodyMassiveDeliveryInProgress: IMassiveDeliveryInProgress[]) => {
  return apiPut(
    `${REACT_APP_SUBSCRIPTION}/order/shipment-status-masive/?shipmentStatusId=3`,
    bodyMassiveDeliveryInProgress
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const massUpdateInProgressToDelivery = async (bodyMassiveDeliveryInProgress: IMassiveDeliveryInProgress[]) => {
  return apiPut(
    `${REACT_APP_SUBSCRIPTION}/order/shipment-status-masive/?shipmentStatusId=4`,
    bodyMassiveDeliveryInProgress
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

export {
  autoUpdateSku,
  goToConfirmed,
  goToDeliveryInProgress,
  goToDeliveryComplete,
  finishDelivery,
  updateDateDelivery,
  massUpdateConfirmedToInProgress,
  massUpdateInProgressToDelivery,
  editEstimatedDeliveryDateInBulk,
  updateToConfirmetToInWarehouse
};
